// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, Input } from "@angular/core";
import { MenuItem } from "../../models/navigationConfig.model";

@Component({
    selector: "gallery-bar",
    standalone: false,
    templateUrl: "./gallery-bar.component.html",
    styleUrl: "./gallery-bar.component.css"
})
export class GalleryBarComponent {
    @Input('menuItems') menuItems: MenuItem[] = [];
}